import * as React from "react";
import { useCallback, useState } from "react";
import usePluginEntities from "hooks/usePluginEntities";
const WidgetOverrideElements = ({ children }) => {
  const widgetOverrideElements = usePluginEntities("views.overrides.widgetEdit");
  const [OverrideComponent, setOverrideComponent] = useState(void 0);
  const retry = useCallback(() => setOverrideComponent(void 0), []);
  const override = useCallback(
    (thrownComponent) => setOverrideComponent(() => thrownComponent),
    []
  );
  if (OverrideComponent) {
    if (OverrideComponent instanceof Error) {
      throw OverrideComponent;
    }
    return /* @__PURE__ */ React.createElement(OverrideComponent, { retry });
  }
  const widgetOverrideChecks = widgetOverrideElements.map((Component, idx) => /* @__PURE__ */ React.createElement(Component, { key: idx, override }));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, widgetOverrideChecks, children);
};
export default WidgetOverrideElements;
